import { Outlet } from 'react-router-dom';

import IntegrationsLayout from '@/components/layouts/IntegrationsLayout';

export default function Integrations() {
  return (
    <>
      <IntegrationsLayout>
        <Outlet />
      </IntegrationsLayout>
    </>
  );
}
